import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import { jsPDF } from "jspdf";
import "jspdf-autotable";

import { usePopup } from "../contexts/PopupContext";
// import { useNavigate } from 'react-router-dom';
import { useNavigation } from "../contexts/NavigationContext";

import CreateStudent from "../forms/CreateStudent";
import Enrollment from "../forms/Enrollment";
import GradeOnAssignment from "../forms/GradeOnAssignment";
import GradeOnEnrollment from "../forms/GradeOnEnrollment";
import AddPaymentRecord from "../forms/AddPaymentRecord";

import {
  faPlus,
  faPercent,
  faHandHoldingDollar,
  faEye,
  faTableList,
  faFileLines,
  faPen,
  faTrashCan,
  faListCheck,
  faMagnifyingGlass,
  faBook,
  faFileCircleCheck,
  faCertificate,
  faDownload,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  Wrapper,
  Header,
  ControlWrapper,
  H2,
  SearchInput,
  IconButton,
} from "./shared_pages_styles";
import {
  TableSection,
  H4,
  Table,
  Th,
  Td,
  Tr,
  TableIconButton,
} from "../table_styles";

import { deleteStudent, setStudents } from "../actions/studentActions";
import { setSelectedStudent } from "../actions/selectionActions";
import { setInitialState } from "../actions/usersActions";
import LoadingSpinner from "../components/LoadingSpinner";

export const Students = () => {
  const studentsArray = useSelector((state) =>
    state.students ? state.students : null
  );
  const enrollmentsArray = useSelector((state) =>
    state.enrollments ? state.enrollments : null
  );
  const assignmentsArray = useSelector((state) =>
    state.assignments ? state.assignments : null
  );
  const gradesArray = useSelector((state) =>
    state.grades ? state.grades : null
  );
  const subjectInstancesArray = useSelector((state) =>
    state.subjectInstances ? state.subjectInstances : null
  );
  const attendancesArray = useSelector((state) =>
    state.attendances ? state.attendances : null
  );

  const today = new Date();
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredEnrollments, setFilteredEnrollments] = useState("");
  const [filteredStudents, setFilteredStudents] = useState("");
  // const [loading, setLoading] = useState(true);
  const doneLoading = useSelector((state) => state.loading.doneLoading);

  const { openPopup } = usePopup();
  // const navigate = useNavigate();
  const dispatch = useDispatch();
  const { navigateTo } = useNavigation();

  useEffect(() => {
    window.scrollTo(0, 0);
    // if (!studentsArray || studentsArray?.length == 0) {
    //   dispatch(setStudents());
    // }
    // if (!subjectInstancesArray || subjectInstancesArray?.length == 0) {
    //   dispatch(setSubjectInstances());
    // }
    if (
      !studentsArray ||
      studentsArray?.length == 0 ||
      !subjectInstancesArray ||
      subjectInstancesArray?.length == 0
    ) {
      dispatch(setInitialState());
    }
  }, []);
  useEffect(() => {
    // if(){
    //   setLoading(false);
    // }

    let filtered = [];
    if (enrollmentsArray && enrollmentsArray.length > 0) {
      filtered = enrollmentsArray.filter(
        (enrollment) =>
          enrollment.student &&
          (enrollment.student.name
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) ||
            enrollment.student.phone.includes(searchTerm) ||
            enrollment.student.mail.toLowerCase().includes(searchTerm) ||
            enrollment.subjectInstance.subject.name
              .toLowerCase()
              .includes(searchTerm.toLowerCase()) ||
            enrollment.subjectInstance.subject.abbreviation
              .toLowerCase()
              .includes(searchTerm.toLowerCase()))
      );
    }
    setFilteredEnrollments(filtered);

    let filteredSt = [];
    if (studentsArray && studentsArray.length > 0) {
      filteredSt = studentsArray.filter(
        (student) =>
          student.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
          student.phone.includes(searchTerm) ||
          student.mail.toLowerCase().includes(searchTerm)
      );
    }
    setFilteredStudents(filteredSt);
  }, [searchTerm, studentsArray, enrollmentsArray]);

  const handleSeeStudent = (student) => {
    const selectedstudent = studentsArray.find((st) => st._id == student._id);
    dispatch(setSelectedStudent(selectedstudent));
    navigateTo(`/student/${student._id}`);
  };
  const handleCreateStudent = () => {
    openPopup(<CreateStudent />);
  };
  const handlePay = (student) => {
    dispatch(setSelectedStudent(student));
    openPopup(<AddPaymentRecord studentId={student._id} />);
  };
  const handleEnrollment = async (student) => {
    dispatch(setSelectedStudent(student));
    openPopup(<Enrollment studentId={student._id} />);
  };
  const handleGradeSubject = (student) => {
    dispatch(setSelectedStudent(student));
    openPopup(<GradeOnEnrollment studentId={student._id} />);
  };
  const handleGradeAssignment = (student) => {
    dispatch(setSelectedStudent(student));
    openPopup(<GradeOnAssignment studentId={student._id} />);
  };
  const handleDeleteStudent = (studentId) => {
    dispatch(deleteStudent(studentId));
  };

  const generatePdf = () => {
    const filteredStudents = studentsArray
      .filter((student) => student.debt > 0)
      .sort((a, b) => b.debt - a.debt);

    const doc = new jsPDF();

    const headerColor = [96, 3, 3]; // RGB color for #600303
    doc.setFont("Helvetica", "bold");
    doc.setFontSize(22);
    doc.setTextColor(headerColor[0], headerColor[1], headerColor[2]);

    doc.text("Students with debt", 14, 20);

    doc.autoTable({
      startY: 30,
      head: [["Name", "Phone", "Debt"]],
      body: filteredStudents.map((student) => [
        student.name,
        student.phone,
        student.debt,
      ]),
      headStyles: { fillColor: "#600303" },
    });

    doc.save("students_debt.pdf");
  };

  if (!doneLoading) {
    return <LoadingSpinner />;
  }
  return (
    <Wrapper>
      <Header>
        <H2>Students</H2>
        <ControlWrapper>
          <SearchInput
            type="text"
            placeholder="Search..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <IconButton onClick={handleCreateStudent}>
            <FontAwesomeIcon icon={faPlus} />
          </IconButton>
          <IconButton onClick={generatePdf}>
            <FontAwesomeIcon icon={faDownload} />
          </IconButton>
        </ControlWrapper>
      </Header>

      <TableSection>
        <H4>Active Students</H4>
        <Table>
          <thead>
            <Tr>
              <Th>Name</Th>
              <Th>Phone</Th>
              <Th>Email</Th>
              <Th>Currency</Th>
              <Th>Debt</Th>
              <Th>Subjects</Th>
              <Th>Absenses</Th>
              <Th>Pending Assignments</Th>
              <Th>Actions</Th>
            </Tr>
          </thead>
          <tbody>
            {filteredEnrollments &&
              filteredEnrollments
                .filter((enrollment) => enrollment.status === "enrolled")
                .reduce((grouped, enrollment) => {
                  const studentId = enrollment.student._id;
                  const existingStudent = grouped.find(
                    (student) => student._id === studentId
                  );
                  if (existingStudent) {
                    existingStudent.enrollments.push(enrollment);
                  } else {
                    grouped.push({
                      birthdate: enrollment.student.birthdate,
                      church: enrollment.student.church,
                      city: enrollment.student.city,
                      debt: enrollment.student.debt,
                      document: enrollment.student.document,
                      education_level: enrollment.student.education_level,
                      mail: enrollment.student.mail,
                      name: enrollment.student.name,
                      phone: enrollment.student.phone,
                      pendingMandatorySubjectCodes:
                        enrollment.student.pendingMandatorySubjectCodes,
                      __typename: "Student",
                      _id: studentId,
                      enrollments: [enrollment],
                    });
                  }
                  return grouped;
                }, [])
                .map((student) => {
                  return (
                    <Tr key={student._id}>
                      <Td>
                        {
                          studentsArray.find((st) => st._id == student._id)
                            ?.name
                        }
                      </Td>
                      <Td>
                        {
                          studentsArray.find((st) => st._id == student._id)
                            ?.phone
                        }
                      </Td>
                      <Td>
                        {
                          studentsArray.find((st) => st._id == student._id)
                            ?.mail
                        }
                      </Td>
                      <Td>
                        {
                          studentsArray.find((st) => st._id == student._id)
                            ?.currency
                        }
                      </Td>
                      <Td>
                        {
                          studentsArray.find((st) => st._id == student._id)
                            ?.debt
                        }
                      </Td>
                      <Td>
                        {enrollmentsArray
                          .filter(
                            (en) =>
                              en.student._id == student._id &&
                              en.status === "enrolled"
                          )
                          ?.map(
                            (enrollment) =>
                              subjectInstancesArray.find(
                                (subjectInstance) =>
                                  enrollment.subjectInstance._id ==
                                  subjectInstance._id
                              )?.subject.abbreviation
                          )
                          .toString()}
                      </Td>
                      <Td>
                        {
                          attendancesArray.filter(
                            (at) =>
                              at.enrollment.student._id == student._id &&
                              at.status == "Ausente" &&
                              at.enrollment.status == "enrolled"
                          ).length
                        }
                      </Td>
                      <Td>
                        {assignmentsArray.length > 0 &&
                          enrollmentsArray
                            .filter(
                              (enrollment) =>
                                enrollment.student._id === student._id
                            )
                            .reduce((total, enrollment) => {
                              const subjectInstanceId =
                                enrollment?.subjectInstance?._id;
                              const assignmentsForInstance =
                                assignmentsArray?.filter(
                                  (assignment) =>
                                    assignment?.subjectInstance?._id ===
                                    subjectInstanceId
                                );
                              return (
                                total +
                                assignmentsForInstance?.filter((assignment) => {
                                  if (!gradesArray) {
                                    return 1;
                                  }
                                  return (
                                      gradesArray?.some(
                                        (grade) =>
                                          grade?.student?._id === student._id &&
                                          grade?.assignment?._id ===
                                            assignment?._id
                                      )
                                    ) ?
                                      0
                                    : 1;
                                }).length
                              );
                            }, 0)}
                      </Td>
                      <Td>
                        <TableIconButton
                          onClick={() => handleSeeStudent(student)}
                        >
                          <FontAwesomeIcon icon={faEye} />
                        </TableIconButton>
                        <TableIconButton
                          onClick={() => handleDeleteStudent(student._id)}
                        >
                          <FontAwesomeIcon icon={faTrashCan} />
                        </TableIconButton>
                        <TableIconButton onClick={() => handlePay(student)}>
                          <FontAwesomeIcon icon={faHandHoldingDollar} />
                        </TableIconButton>
                        <TableIconButton
                          onClick={() => handleEnrollment(student)}
                        >
                          <FontAwesomeIcon icon={faBook} />
                        </TableIconButton>
                        <TableIconButton
                          onClick={() => handleGradeSubject(student)}
                        >
                          <FontAwesomeIcon icon={faCertificate} />
                        </TableIconButton>
                        <TableIconButton
                          onClick={() => handleGradeAssignment(student)}
                        >
                          <FontAwesomeIcon icon={faListCheck} />
                        </TableIconButton>
                      </Td>
                    </Tr>
                  );
                })}
          </tbody>
        </Table>
      </TableSection>
      <TableSection>
        <H4>Inactive Students</H4>
        <Table>
          <thead>
            <Tr>
              <Th>Name</Th>
              <Th>Phone</Th>
              <Th>Currency</Th>
              <Th>Debt</Th>
              <Th>Actions</Th>
            </Tr>
          </thead>
          <tbody>
            {filteredStudents &&
              filteredStudents
                .filter(
                  (student) =>
                    !enrollmentsArray.some(
                      (enrollment) =>
                        enrollment.student._id === student._id &&
                        enrollment.status == "enrolled"
                    )
                )
                .map((student, index) => (
                  <Tr key={index}>
                    <Td>{student.name}</Td>
                    <Td>{student.phone}</Td>
                    <Td>{student.currency}</Td>
                    <Td>{student.debt}</Td>
                    <Td>
                      <TableIconButton
                        onClick={() => handleSeeStudent(student)}
                      >
                        <FontAwesomeIcon icon={faEye} />
                      </TableIconButton>
                      <TableIconButton onClick={() => handlePay(student)}>
                        <FontAwesomeIcon icon={faHandHoldingDollar} />
                      </TableIconButton>
                      <TableIconButton
                        onClick={() => handleEnrollment(student)}
                      >
                        <FontAwesomeIcon icon={faBook} />
                      </TableIconButton>
                      <TableIconButton
                        onClick={() => handleDeleteStudent(student._id)}
                      >
                        <FontAwesomeIcon icon={faTrashCan} />
                      </TableIconButton>
                    </Td>
                  </Tr>
                ))}
          </tbody>
        </Table>
      </TableSection>
    </Wrapper>
  );
};

export default Students;
